/**
 * Neutral stroke icons for browse rows: folder-like types vs project.
 * SVG only — no external icon font.
 */

function svgProps(className) {
    return {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 22,
        height: 22,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.5,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        className,
        'aria-hidden': true,
        focusable: false,
    };
}

/** Organization + project-subfolder: closed folder */
function FolderClosedIcon({ className = '' }) {
    return (
        <svg {...svgProps(className)}>
            <path d="M3 7a2 2 0 0 1 2-2h3.5l1.5 2H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
        </svg>
    );
}

/** Project: grid / board (distinct from folder) */
function ProjectGridIcon({ className = '' }) {
    return (
        <svg {...svgProps(className)}>
            <path d="M4 5.5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 10 5.5v3A1.5 1.5 0 0 1 8.5 10h-3A1.5 1.5 0 0 1 4 8.5v-3Z" />
            <path d="M14 5.5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 20 5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 14 8.5v-3Z" />
            <path d="M4 15.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 8.5 21h-3A1.5 1.5 0 0 1 4 18.5v-3Z" />
            <path d="M14 15.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 14 18.5v-3Z" />
        </svg>
    );
}

/**
 * @param {object} props
 * @param {'organization'|'project'|'project-subfolder'|string} props.type - girderProjects.type
 * @param {string} [props.className] - wrapper class
 */
export default function ProjectBrowseKindIcon({ type, className = '' }) {
    const isProject = type === 'project';
    return isProject ? <ProjectGridIcon className={className} /> : <FolderClosedIcon className={className} />;
}
